<div class="mt-4 mb-4" *ngIf="purchaseOrderNumber != 0">
  <ol class="breadcrumb bg-white">
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" [routerLink]="['/purchase/order']">Commandes</button></li>
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" [routerLink]="['/purchase/order', purchaseOrderNumber]">{{ purchaseOrderNumber }}</button></li>
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" disabled>Needa</button></li>
    <li class="breadcrumb-item active">
      <button class="btn btn-sm btn-link" disabled [ngSwitch]="type">
        <span *ngSwitchCase="'ORDER'">Commande</span>
        <span *ngSwitchCase="'ORDER_ACK'">Avis de réception</span>
        <span *ngSwitchCase="'ORDER_CONFIRMATION'">Confirmation</span>
      </button></li>
  </ol>
</div>

<pre class="p-3 bg-white">{{ needaFile }}</pre>